import React, { useState } from "react";
import { GetLogDetailSaoKe } from "../../api/detailProject";
import { Empty, Modal, Table } from "antd";

const ModalLogDetailSaoKe = ({
    isOpenModalLogDetailSaoKe,
    setIsOpenModalLogDetailSaoKe,
    dataLogDetailSaoKe,
}) => {
    const [dataLog, setDataLog] = useState([]);

    const columns = [
        {
            title: "Thời gian",
            dataIndex: "time",
            key: "time",
            align: "center",
        },
        {
            title: "Người thao tác",
            dataIndex: "user",
            key: "user",
            align: "center",
        },
        {
            title: "Chi tiết",
            dataIndex: "detail",
            key: "detail",
            align: "center",
        },
    ];

    const handleCancel = () => {
        setIsOpenModalLogDetailSaoKe(false);
    };

    const getDataLogDetailSaoKe = () => {
        GetLogDetailSaoKe({
            id: dataLogDetailSaoKe.id_detail,
        })
            .then((res) => {
                setDataLog(res.data.log);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    React.useEffect(() => {
        if (isOpenModalLogDetailSaoKe) {
            getDataLogDetailSaoKe();
        }
    }, [isOpenModalLogDetailSaoKe]);

    return (
        <>
            <Modal
                title={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div className="title-bill-log">
                            <span className="title-field-bill" style={{ fontSize: 22 }}>
                                View Log
                            </span>
                        </div>
                    </div>
                }
                open={isOpenModalLogDetailSaoKe}
                onCancel={handleCancel}
                width={1000}
                closable={false}
                footer={false}
                style={{ marginTop: 40 }}
            >
                {dataLog && dataLog.length > 0 ? (
                    <Table
                        columns={columns}
                        dataSource={dataLog}
                        style={{
                            width: "100%",
                            marginTop: 20,
                            overflow: "auto",
                            height: 500,
                        }}
                        pagination={false}
                        className="custom-table table-striped-rows"
                        rowClassName="text-body-log"
                        bordered
                        id="elem_id"
                    />
                ) : (
                    <div>
                        <Empty style={{ display: "initial" }} />
                    </div>
                )}
            </Modal>
        </>
    );
};

export default ModalLogDetailSaoKe;
